import { render, staticRenderFns } from "./conversation-test-widget.vue?vue&type=template&id=4accc320"
import script from "./conversation-test-widget.ts?vue&type=script&lang=ts&external"
export * from "./conversation-test-widget.ts?vue&type=script&lang=ts&external"
import style0 from "./conversation-test-widget.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports